import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <section id='footer'>
        <div className='circel'></div>
        <div className='container'>
            <div className='footer-head'>
                <div className='footer-titel'>
                    <h1>lets work together</h1>
                    <div className='circel-full'></div>
                </div>
                <a href='#contact' className='footer-contact'><h2>Contact</h2><img src='./assets/arrow2.svg' alt='' /></a>
            </div>
            <h3>&copy; Mohcin Charef 2023</h3>
        </div>
    </section>
  )
}

export default Footer